const config = {
	// api: 'http://localhost:7100',
	// api: 'https://demo.beautitag.com/path/api',
	api: 'https://navigate.ust.hk/path/api',
	asset: 'http://navigate.ust.hk/path/asset',
	loginTimeout: 18000000
};

export default config;